import { createTheme, inputClasses, outlinedInputClasses } from "@mui/material";

export const Theme = createTheme({
  palette: {
    black: "#000",
    blue: {
      primaryBlue: "#007AFF",
      light: "#E6F2FF",
      light1: "#CCE4FF",
      light2: "#B3D7FF",
      dark: "#99CAFF",
      dark1: "#66AFFF",
      dark2: "#3395FF",
      dark3: "#0062CC",
    },

    background: {
      paper: "#FFF",
      darkBlue: "#00254D",
      LightBlue: "#66AFFF",
      grayLight05: "#E5E5EA",
      grayDark: "#37373A",
      grayLight: "#8E8E93",
      LightRed: "#FF8982",
      offgrayLight: "#F2F2F7",
      offWhite: "#F7F8FA",
      pureWhite: "#FFF",
      primaryRed: "#FF3B30",
      darkRed: "#CD2F26",
      primaryGreen: "#34C759",
      lightGreen: "#86DD9B",
      grey: "#F5F5FA",
      red: "#FF3B30",
      lightGray: "#DEDEDE59",
    },
    text: {
      primary: "#173A5E",
      secondary: "#46505A",
      grayLight05: "#E5E5EA",
      grayDark: "#37373A",
      grayLight: "#8E8E93",
      gray02Light: "#AEAEB2",
      gray03Light: "#717171",
      offWhite: "#F7F8FA",
      pureWhite: "#FFF",
      blue: "#007AFF",
      pink: "#FF2D55",
      gray: "#747474",
      gray01: "#CCC",
    },
    green: {
      mediumGreen: "#2A9F47",
    },
    action: {
      active: "#001E3C",
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "normal" },
          style: {
            textTransform: "none",
            borderRadius: "7px",
            boxShadow: "0",
          },
        },
        {
          props: { variant: "contained" },
          style: {
            textTransform: "none",
            borderRadius: "7px",
            boxShadow: "0",
          },
        },
        {
          props: { variant: "LightBlueFontOnly" },
          style: {
            textTransform: "none",
            borderRadius: "7px",
            boxShadow: "0",
            fontSize: "13px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "18px",
            background: "transparent",
            color: "#007AFF",
            "&:hover": {
              backgroundColor: "transparent",
              // color: "#FFF",
            },
          },
        },
        {
          props: { variant: "LightBlueFontOnly2" },
          style: {
            textTransform: "none",
            borderRadius: "7px",
            boxShadow: "0",
            fontSize: "15px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
            background: "transparent",
            color: "#007AFF",
            "&:hover": {
              backgroundColor: "transparent",
              // color: "#FFF",
            },
          },
        },
        {
          props: { variant: "green" },
          style: {
            textTransform: "none",
            backgroundColor: "#34C759",
            borderRadius: "7px",
            boxShadow: "0",
          },
        },
        {
          // button lightBlue
          props: { variant: "lightBlue" },
          style: {
            height: "50px",
            textTransform: "none",
            backgroundColor: "#0062CC",
            borderRadius: "10px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "18px",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#004999",
              color: "#FFFFFF",
            },
          },
        },
        {
          // button lightBlue
          props: { variant: "lightBlueBase" },
          style: {
            height: "50px",
            textTransform: "none",
            backgroundColor: "#0062CC",
            borderRadius: "10px",
            boxShadow: "0",
            color: "#FFFFFF",
            border: "1px solid var(--system-blue-light-5-primary, #0062CC)",
            "&:hover": {
              backgroundColor: "#004999",
              color: "#FFFFFF",
            },
          },
        },
        {
          props: { variant: "mediumBlue" },
          style: {
            textTransform: "none",
            backgroundColor: "#007AFF",
            borderRadius: "10px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "18px",
            color: "#FFF",
          },
        },
        {
          props: { variant: "mediumActive" },
          style: {
            textTransform: "none",
            backgroundColor: "#0062CC",
            borderRadius: "5px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "400",
            fontStyle: "normal",
            lineHeight: "18px",
            color: "#FFF",
            height: "26px",
            "&:hover": {
              backgroundColor: "#0062CC",
              color: "#FFF",
            },
          },
        },
        {
          props: { variant: "mediumInActive" },
          style: {
            textTransform: "none",
            backgroundColor: "#F5F5FA",
            borderRadius: "5px",
            border: "1px solid var(--gray-07, #717171)",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "400",
            fontStyle: "normal",
            lineHeight: "18px",
            color: "#717171",
            height: "26px",
            "&:hover": {
              backgroundColor: "#F5F5FA",
              color: "#717171",
            },
          },
        },
        {
          props: { variant: "primaryBlue" },
          style: {
            textTransform: "none",
            height: "50px",
            backgroundColor: "#0062CC",
            borderRadius: "14px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "20px",
            color: "#FFF",
            padding: " 14px 20px",
            "&:hover": {
              backgroundColor: "#004999",
              color: "#FFF",
            },
          },
        },
        {
          props: { variant: "primaryRed" },
          style: {
            textTransform: "none",
            backgroundColor: "#FF3B30",
            borderRadius: "14px",
            boxShadow: "0",
            fontSize: "15px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "20px",
            color: "#FFF",
            padding: " 14px 20px",
            "&:hover": {
              backgroundColor: "#007AFF",
              color: "#FFF",
            },
          },
        },
        {
          props: { variant: "whiteSquare" },
          style: {
            textTransform: "none",
            backgroundColor: "white",
            borderRadius: "10px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "18px",
            color: "#007AFF",
            height: "42px",
            "&:hover": {
              backgroundColor: "transparent",
              // color: "#FFF",
            },
          },
        },
        {
          props: { variant: "OuterLineBlue" },
          style: {
            textTransform: "none",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "18px",
            color: "#0062CC",
            border: "1px solid var(--system-blue-light-5-primary, #0062CC)",
            "&:hover": {
              border: "1px solid var(--system-blue-light-5-primary, #0062CC)",
              backgroundColor: "#EFF9FE",
              color: "#0062CC",
            },
          },
        },
        {
          props: { variant: "OuterLineBlueBase" },
          style: {
            textTransform: "none",
            backgroundColor: "#fff",
            boxShadow: "0",
            color: "#0062CC",
            border: "1px solid var(--system-blue-light-5-primary, #0062CC)",
            "&:hover": {
              border: "1px solid var(--system-blue-light-5-primary, #0062CC)",
              backgroundColor: "#EFF9FE",
              color: "#0062CC",
            },
          },
        },
        {
          props: { variant: "OuterLineGreyBase" },
          style: {
            textTransform: "none",
            backgroundColor: "#fff",
            boxShadow: "0",
            color: "#CCC",
            border: "1px solid #CCC",
            "&:hover": {
              border: "1px solid #CCC",
              backgroundColor: "#EFF9FE",
              color: "#CCC",
            },
          },
        },
        {
          props: { variant: "OuterLineRed" },
          style: {
            textTransform: "none",
            backgroundColor: "#fff",
            color: "#FF3B30",
            border: "1px solid var(--system-blue-light-5-primary, #FF3B30)",
            "&:hover": {
              border: "1px solid var(--system-blue-light-5-primary, #FF3B30)",
              backgroundColor: "#FFEBEA",
              color: "#FF3B30",
            },
          },
        },
        {
          props: { variant: "blueSqaure" },
          style: {
            textTransform: "none",
            backgroundColor: "#007AFF",
            borderRadius: "0px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "400",
            fontStyle: "normal",
            lineHeight: "18px",
            padding: "8px 20px",
            color: "#FFF",
          },
        },
        {
          props: { variant: "lightBlueSqaure" },
          style: {
            textTransform: "none",
            backgroundColor: "#E5F2FF",
            borderRadius: "0px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "400",
            fontStyle: "normal",
            lineHeight: "18px",
            padding: "8px 20px",
            color: "#000000",
            "&:hover": {
              backgroundColor: "#007AFF",
              color: "#FFF",
            },
          },
        },
      ],
    },
    MuiPaper: {
      variants: [
        {
          props: { variant: "White16" },
          style: {
            textTransform: "none",
            backgroundColor: "#FFF",
            borderRadius: "16px",
            boxShadow: "0px 0px 25px 0px rgba(0, 0, 0, 0.05)",
            alignItems: "center",
            justifyItems: "center",
            display: "flex",
          },
        },
        {
          props: { variant: "White0.5" },
          style: {
            textTransform: "none",
            backgroundColor: "#FFF",
            borderRadius: "10px",
            boxShadow: "0px 0px 25px 0px rgba(0, 0, 0, 0.05)",
            alignItems: "center",
            justifyItems: "center",
            display: "flex",
            padding: "24px 20px",
          },
        },
        {
          props: { variant: "LightRed" },
          style: {
            textTransform: "none",
            backgroundColor: "#FF8982",
            borderRadius: "5px",
            boxShadow: "0",
            alignSelf: "stretch",
            padding: "8px",
            alignItems: "center",
            display: "flex",
          },
        },
        {
          props: { variant: "LightBlue" },
          style: {
            textTransform: "none",
            backgroundColor: "#DEF4FE",
            borderRadius: "15px",
            boxShadow: "0",
            alignSelf: "stretch",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            border: "1px solid var(--system-blue-light-1, #CCE4FF)",
          },
        },
        {
          props: { variant: "danger" },
          style: {
            textTransform: "none",
            backgroundColor: "#FFEBEA",
            borderRadius: "15px",
            boxShadow: "0",
            alignSelf: "stretch",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            border: "1px solid var(--system-red-light-1, #FFD8D5)",
          },
        },
        {
          props: { variant: "LightSkyBlue" },
          style: {
            textTransform: "none",
            backgroundColor: "#EBF9EE",
            borderRadius: "15px",
            boxShadow: "0",
            alignSelf: "stretch",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          },
        },
        {
          props: { variant: "PaleGreen" },
          style: {
            textTransform: "none",
            backgroundColor: "#D7F4DE",
            borderRadius: "8px 0px 0px 8px",
            boxShadow: "0",
            alignSelf: "stretch",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          },
        },
        {
          props: { variant: "LightGreen" },
          style: {
            height: "24px",
            borderRadius: "24px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            boxShadow: "0",
            backgroundColor: "#86DD9B",
          },
        },
        {
          props: { variant: "PrimaryBlue" },
          style: {
            height: "24px",
            borderRadius: "24px",
            justifyContent: "center",
            alignItems: "center",
            padding: "4px 12px",
            display: "flex",
            boxShadow: "0",
            backgroundColor: "#007AFF",
          },
        },
        {
          props: { variant: "Orange" },
          style: {
            height: "24px",
            borderRadius: "24px",
            justifyContent: "center",
            padding: "4px 12px",
            alignItems: "center",
            display: "flex",
            boxShadow: "0",
            backgroundColor: "#FF9500",
          },
        },
        {
          props: { variant: "LightGrey" },
          style: {
            textTransform: "none",
            backgroundColor: "#E5E5EA",
            borderRadius: "5px",
            boxShadow: "0",
            alignSelf: "stretch",
            padding: "8px",
            alignItems: "center",
            display: "flex",
          },
        },
        {
          props: { variant: "LightPearlGrey" },
          style: {
            textTransform: "none",
            backgroundColor: "#F2F2F7",

            alignSelf: "stretch",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          },
        },
      ],
    },
    MuiToggleButton: {
      variants: [
        {
          props: { variant: "primaryBlue" },
          style: {
            textTransform: "none",
            backgroundColor: "#007AFF",
            borderRadius: "14px",
            boxShadow: "0",
            fontSize: "15px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "20px",
            color: "#FFF",
            padding: " 14px 20px",
            "&:hover": {
              backgroundColor: "#007AFF",
              color: "#FFF",
            },
            "&.Mui-selected": {
              backgroundColor: "#0062CC",
              color: "#FFF",
            },
          },
        },
        {
          props: { variant: "lightBlueSqaure" },
          style: {
            textTransform: "none",
            backgroundColor: "#E5F2FF",
            borderRadius: "0px",
            boxShadow: "0",
            fontSize: "13px",
            fontWeight: "400",
            fontStyle: "normal",
            lineHeight: "18px",
            padding: "8px 20px",
            color: "#000000",
            "&:hover": {
              backgroundColor: "#cde3fa",
              color: "#FFF",
            },
            "&.Mui-selected": {
              backgroundColor: "#007AFF",
              color: "#FFF",
            },
          },
        },
      ],
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: "7px",
          height: "50px",
          fontSize: "13px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: "7px",
          minHeight: "50px",
          fontSize: "13px",
          "& label.Mui-focused": {
            color: "#37373A",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: "#E5E5EA",
          },
          [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
            borderStyle: "solid",
            borderColor: "#37373A",
            borderWidth: "1px",
          },
          [`&.Mui-disabled `]: {
            background: "#F2F2F7",
          },
          [`&.${inputClasses.multiline}`]: {
            height: "auto",
            padding: "0px !important",
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: "50px",
          fontSize: "13px",

          "& fieldset": {
            borderRadius: "7px",
            borderColor: "#E5E5EA",
          },
          "&.Mui-error fieldset.MuiOutlinedInput-notchedOutline": {
            borderColor: "#FF3B30",
          },
        },
        input: {
          padding: "15px 16px !important",

          color: "#37373A",
          height: "50px",
          boxSizing: "border-box",
          "::placeholder": {
            color: "#8E8E93",
          },
          "&.Mui-disabled": {
            color: "#8E8E93 !important",
            WebkitTextFillColor: "#8E8E93",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0, // Set marginLeft to 0 to remove the left space
          marginTop: "4px !important",
          color: "#FF3B30 !important",
        },
        error: {},
      },
    },
    // Exclude the input styling for AutoComplete
    MuiAutocomplete: {
      styleOverrides: {
        root: {},
        input: {
          height: "auto", // Set the height to "auto" or remove this property
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: "24px",
        },
      },
    },
  },
});
